// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

// This was generated using spacetimedb cli version 2.0.5 (commit d60138999206c06c776829072f46b5d1c1101f7e).

/* eslint-disable */
/* tslint:disable */
import {
  DbConnectionBuilder as __DbConnectionBuilder,
  DbConnectionImpl as __DbConnectionImpl,
  SubscriptionBuilderImpl as __SubscriptionBuilderImpl,
  TypeBuilder as __TypeBuilder,
  Uuid as __Uuid,
  convertToAccessorMap as __convertToAccessorMap,
  makeQueryBuilder as __makeQueryBuilder,
  procedureSchema as __procedureSchema,
  procedures as __procedures,
  reducerSchema as __reducerSchema,
  reducers as __reducers,
  schema as __schema,
  t as __t,
  table as __table,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type DbConnectionConfig as __DbConnectionConfig,
  type ErrorContextInterface as __ErrorContextInterface,
  type Event as __Event,
  type EventContextInterface as __EventContextInterface,
  type Infer as __Infer,
  type QueryBuilder as __QueryBuilder,
  type ReducerEventContextInterface as __ReducerEventContextInterface,
  type RemoteModule as __RemoteModule,
  type SubscriptionEventContextInterface as __SubscriptionEventContextInterface,
  type SubscriptionHandleImpl as __SubscriptionHandleImpl,
} from "spacetimedb";

// Import all reducer arg schemas
import AcceptMailTradeReducer from "./accept_mail_trade_reducer";
import AddFriendReducer from "./add_friend_reducer";
import AddToItemBarReducer from "./add_to_item_bar_reducer";
import AddToSkillBarReducer from "./add_to_skill_bar_reducer";
import AddToSkillBarAtReducer from "./add_to_skill_bar_at_reducer";
import AdminAddMapObjectReducer from "./admin_add_map_object_reducer";
import AdminAddPortalReducer from "./admin_add_portal_reducer";
import AdminAddPortalAutoReducer from "./admin_add_portal_auto_reducer";
import AdminAddSpawnPointReducer from "./admin_add_spawn_point_reducer";
import AdminBringPlayerHereReducer from "./admin_bring_player_here_reducer";
import AdminCreateInstanceReducer from "./admin_create_instance_reducer";
import AdminCreateMapReducer from "./admin_create_map_reducer";
import AdminDeleteMapReducer from "./admin_delete_map_reducer";
import AdminDisconnectPlayerSessionReducer from "./admin_disconnect_player_session_reducer";
import AdminImportMapJsonReducer from "./admin_import_map_json_reducer";
import AdminMovePlayerToMapReducer from "./admin_move_player_to_map_reducer";
import AdminPlaceNpcReducer from "./admin_place_npc_reducer";
import AdminReloadMapAssetReducer from "./admin_reload_map_asset_reducer";
import AdminRemoveMapObjectReducer from "./admin_remove_map_object_reducer";
import AdminRemoveNpcReducer from "./admin_remove_npc_reducer";
import AdminRemovePortalReducer from "./admin_remove_portal_reducer";
import AdminSetGameManagerRoleReducer from "./admin_set_game_manager_role_reducer";
import AdminSetMapBiomeRegionReducer from "./admin_set_map_biome_region_reducer";
import AdminSetMapDefaultBiomeReducer from "./admin_set_map_default_biome_reducer";
import AdminSetMapPathBorderContinuationReducer from "./admin_set_map_path_border_continuation_reducer";
import AdminSetMapPathCellReducer from "./admin_set_map_path_cell_reducer";
import AdminSetMapPathTileReducer from "./admin_set_map_path_tile_reducer";
import AdminSetMapTileReducer from "./admin_set_map_tile_reducer";
import AdminSetPlayerDifficultyReducer from "./admin_set_player_difficulty_reducer";
import CancelStatusEffectReducer from "./cancel_status_effect_reducer";
import CancelTradeReducer from "./cancel_trade_reducer";
import ClearIntentQueueReducer from "./clear_intent_queue_reducer";
import CreateGuildReducer from "./create_guild_reducer";
import DeleteMailReducer from "./delete_mail_reducer";
import EnqueueIntentReducer from "./enqueue_intent_reducer";
import EnterDungeonReducer from "./enter_dungeon_reducer";
import EquipItemReducer from "./equip_item_reducer";
import ForceReseedMapsReducer from "./force_reseed_maps_reducer";
import JoinGuildReducer from "./join_guild_reducer";
import LeaveGuildReducer from "./leave_guild_reducer";
import LoginReducer from "./login_reducer";
import LogoutReducer from "./logout_reducer";
import MarkIncomingTradesReadReducer from "./mark_incoming_trades_read_reducer";
import MarkMailReadReducer from "./mark_mail_read_reducer";
import MarkMessagesReadReducer from "./mark_messages_read_reducer";
import MoveChestItemReducer from "./move_chest_item_reducer";
import MoveInventoryItemReducer from "./move_inventory_item_reducer";
import MoveInventoryToStorageReducer from "./move_inventory_to_storage_reducer";
import MoveStorageItemReducer from "./move_storage_item_reducer";
import MoveStorageToInventoryReducer from "./move_storage_to_inventory_reducer";
import PersistTickResultReducer from "./persist_tick_result_reducer";
import RefreshSessionLeaseReducer from "./refresh_session_lease_reducer";
import RegisterPlayerReducer from "./register_player_reducer";
import RemoveFriendReducer from "./remove_friend_reducer";
import RemoveFromItemBarReducer from "./remove_from_item_bar_reducer";
import RemoveFromSkillBarReducer from "./remove_from_skill_bar_reducer";
import SendChatReducer from "./send_chat_reducer";
import SendMailReducer from "./send_mail_reducer";
import SetMyAppearanceReducer from "./set_my_appearance_reducer";
import SplitChestItemReducer from "./split_chest_item_reducer";
import SplitInventoryItemReducer from "./split_inventory_item_reducer";
import StartTickerReducer from "./start_ticker_reducer";
import TakeItemFromChestReducer from "./take_item_from_chest_reducer";
import TakeItemFromChestToSlotReducer from "./take_item_from_chest_to_slot_reducer";
import UnequipItemReducer from "./unequip_item_reducer";
import UpdatePlayerPositionReducer from "./update_player_position_reducer";
import UseItemOnTileReducer from "./use_item_on_tile_reducer";
import UsePortalReducer from "./use_portal_reducer";
import VerifyInventoryAccessReducer from "./verify_inventory_access_reducer";
import VerifyItemDefinitionAccessReducer from "./verify_item_definition_access_reducer";
import VerifyMapAccessReducer from "./verify_map_access_reducer";
import VerifyTradeTargetReducer from "./verify_trade_target_reducer";

// Import all procedure arg schemas

// Import all table schema definitions
import AccessibleChestInventoryRow from "./accessible_chest_inventory_table";
import AdminMapCatalogRow from "./admin_map_catalog_table";
import AppearanceDefinitionsRow from "./appearance_definitions_table";
import CurrentMapDefinitionRow from "./current_map_definition_table";
import CurrentMapInstanceRow from "./current_map_instance_table";
import CurrentMapNpcsRow from "./current_map_npcs_table";
import CurrentMapObjectsRow from "./current_map_objects_table";
import CurrentMapPortalsRow from "./current_map_portals_table";
import CurrentMapRuntimeEntitiesRow from "./current_map_runtime_entities_table";
import CurrentMapRuntimeNpcsRow from "./current_map_runtime_npcs_table";
import GameItemsRow from "./game_items_table";
import GameRuntimeControlRow from "./game_runtime_control_table";
import GameStateRow from "./game_state_table";
import GameTickConfigRow from "./game_tick_config_table";
import MobDefinitionsRow from "./mob_definitions_table";
import MyAdminStatusRow from "./my_admin_status_table";
import MyChatCommandsRow from "./my_chat_commands_table";
import MyChatFeedRow from "./my_chat_feed_table";
import MyEquipmentRow from "./my_equipment_table";
import MyFriendsRow from "./my_friends_table";
import MyGuildRow from "./my_guild_table";
import MyIncomingTradesRow from "./my_incoming_trades_table";
import MyIntentQueueRow from "./my_intent_queue_table";
import MyInventoryRow from "./my_inventory_table";
import MyItemBarRow from "./my_item_bar_table";
import MyMailboxInboxRow from "./my_mailbox_inbox_table";
import MyMailboxMessagesRow from "./my_mailbox_messages_table";
import MyMapEventsRow from "./my_map_events_table";
import MyOutgoingTradesRow from "./my_outgoing_trades_table";
import MyPlayerRow from "./my_player_table";
import MyRelatedTradeInventoriesRow from "./my_related_trade_inventories_table";
import MySkillBarRow from "./my_skill_bar_table";
import MySkillsRow from "./my_skills_table";
import MyStatusEffectsRow from "./my_status_effects_table";
import MyStorageRow from "./my_storage_table";
import MyTradeTargetInventoryRow from "./my_trade_target_inventory_table";
import MyUnreadMailboxCountsRow from "./my_unread_mailbox_counts_table";
import MyVisibleActiveZonesRow from "./my_visible_active_zones_table";
import SkillDefinitionsRow from "./skill_definitions_table";
import VisibleActorInventoryRow from "./visible_actor_inventory_table";
import VisiblePlayerIdentityRow from "./visible_player_identity_table";
import VisiblePlayersRow from "./visible_players_table";

/** Type-only namespace exports for generated type groups. */

/** The schema information for all tables in this module. This is defined the same was as the tables would have been defined in the server. */
const tablesSchema = __schema({
  game_items: __table({
    name: 'game_items',
    indexes: [
      { accessor: 'item_id', name: 'game_items_item_id_idx_btree', algorithm: 'btree', columns: [
        'itemId',
      ] },
      { accessor: 'game_items_type_idx', name: 'game_items_item_type_idx_btree', algorithm: 'btree', columns: [
        'itemType',
      ] },
    ],
    constraints: [
      { name: 'game_items_item_id_key', constraint: 'unique', columns: ['itemId'] },
    ],
  }, GameItemsRow),
  game_runtime_control: __table({
    name: 'game_runtime_control',
    indexes: [
      { accessor: 'singleton_id', name: 'game_runtime_control_singleton_id_idx_btree', algorithm: 'btree', columns: [
        'singletonId',
      ] },
    ],
    constraints: [
      { name: 'game_runtime_control_singleton_id_key', constraint: 'unique', columns: ['singletonId'] },
    ],
  }, GameRuntimeControlRow),
  game_state: __table({
    name: 'game_state',
    indexes: [
      { accessor: 'singleton_id', name: 'game_state_singleton_id_idx_btree', algorithm: 'btree', columns: [
        'singletonId',
      ] },
    ],
    constraints: [
      { name: 'game_state_singleton_id_key', constraint: 'unique', columns: ['singletonId'] },
    ],
  }, GameStateRow),
  game_tick_config: __table({
    name: 'game_tick_config',
    indexes: [
      { accessor: 'singleton_id', name: 'game_tick_config_singleton_id_idx_btree', algorithm: 'btree', columns: [
        'singletonId',
      ] },
    ],
    constraints: [
      { name: 'game_tick_config_singleton_id_key', constraint: 'unique', columns: ['singletonId'] },
    ],
  }, GameTickConfigRow),
  skill_definitions: __table({
    name: 'skill_definitions',
    indexes: [
      { accessor: 'skill_definitions_name_idx', name: 'skill_definitions_display_name_idx_btree', algorithm: 'btree', columns: [
        'displayName',
      ] },
      { accessor: 'skill_id', name: 'skill_definitions_skill_id_idx_btree', algorithm: 'btree', columns: [
        'skillId',
      ] },
    ],
    constraints: [
      { name: 'skill_definitions_skill_id_key', constraint: 'unique', columns: ['skillId'] },
    ],
  }, SkillDefinitionsRow),
  accessible_chest_inventory: __table({
    name: 'accessible_chest_inventory',
    indexes: [
    ],
    constraints: [
    ],
  }, AccessibleChestInventoryRow),
  admin_map_catalog: __table({
    name: 'admin_map_catalog',
    indexes: [
    ],
    constraints: [
    ],
  }, AdminMapCatalogRow),
  appearance_definitions: __table({
    name: 'appearance_definitions',
    indexes: [
    ],
    constraints: [
    ],
  }, AppearanceDefinitionsRow),
  current_map_definition: __table({
    name: 'current_map_definition',
    indexes: [
    ],
    constraints: [
    ],
  }, CurrentMapDefinitionRow),
  current_map_instance: __table({
    name: 'current_map_instance',
    indexes: [
    ],
    constraints: [
    ],
  }, CurrentMapInstanceRow),
  current_map_npcs: __table({
    name: 'current_map_npcs',
    indexes: [
    ],
    constraints: [
    ],
  }, CurrentMapNpcsRow),
  current_map_objects: __table({
    name: 'current_map_objects',
    indexes: [
    ],
    constraints: [
    ],
  }, CurrentMapObjectsRow),
  current_map_portals: __table({
    name: 'current_map_portals',
    indexes: [
    ],
    constraints: [
    ],
  }, CurrentMapPortalsRow),
  current_map_runtime_entities: __table({
    name: 'current_map_runtime_entities',
    indexes: [
    ],
    constraints: [
    ],
  }, CurrentMapRuntimeEntitiesRow),
  current_map_runtime_npcs: __table({
    name: 'current_map_runtime_npcs',
    indexes: [
    ],
    constraints: [
    ],
  }, CurrentMapRuntimeNpcsRow),
  mob_definitions: __table({
    name: 'mob_definitions',
    indexes: [
    ],
    constraints: [
    ],
  }, MobDefinitionsRow),
  my_admin_status: __table({
    name: 'my_admin_status',
    indexes: [
    ],
    constraints: [
    ],
  }, MyAdminStatusRow),
  my_chat_commands: __table({
    name: 'my_chat_commands',
    indexes: [
    ],
    constraints: [
    ],
  }, MyChatCommandsRow),
  my_chat_feed: __table({
    name: 'my_chat_feed',
    indexes: [
    ],
    constraints: [
    ],
  }, MyChatFeedRow),
  my_equipment: __table({
    name: 'my_equipment',
    indexes: [
    ],
    constraints: [
    ],
  }, MyEquipmentRow),
  my_friends: __table({
    name: 'my_friends',
    indexes: [
    ],
    constraints: [
    ],
  }, MyFriendsRow),
  my_guild: __table({
    name: 'my_guild',
    indexes: [
    ],
    constraints: [
    ],
  }, MyGuildRow),
  my_incoming_trades: __table({
    name: 'my_incoming_trades',
    indexes: [
    ],
    constraints: [
    ],
  }, MyIncomingTradesRow),
  my_intent_queue: __table({
    name: 'my_intent_queue',
    indexes: [
    ],
    constraints: [
    ],
  }, MyIntentQueueRow),
  my_inventory: __table({
    name: 'my_inventory',
    indexes: [
    ],
    constraints: [
    ],
  }, MyInventoryRow),
  my_item_bar: __table({
    name: 'my_item_bar',
    indexes: [
    ],
    constraints: [
    ],
  }, MyItemBarRow),
  my_mailbox_inbox: __table({
    name: 'my_mailbox_inbox',
    indexes: [
    ],
    constraints: [
    ],
  }, MyMailboxInboxRow),
  my_mailbox_messages: __table({
    name: 'my_mailbox_messages',
    indexes: [
    ],
    constraints: [
    ],
  }, MyMailboxMessagesRow),
  my_map_events: __table({
    name: 'my_map_events',
    indexes: [
    ],
    constraints: [
    ],
  }, MyMapEventsRow),
  my_outgoing_trades: __table({
    name: 'my_outgoing_trades',
    indexes: [
    ],
    constraints: [
    ],
  }, MyOutgoingTradesRow),
  my_player: __table({
    name: 'my_player',
    indexes: [
    ],
    constraints: [
    ],
  }, MyPlayerRow),
  my_related_trade_inventories: __table({
    name: 'my_related_trade_inventories',
    indexes: [
    ],
    constraints: [
    ],
  }, MyRelatedTradeInventoriesRow),
  my_skill_bar: __table({
    name: 'my_skill_bar',
    indexes: [
    ],
    constraints: [
    ],
  }, MySkillBarRow),
  my_skills: __table({
    name: 'my_skills',
    indexes: [
    ],
    constraints: [
    ],
  }, MySkillsRow),
  my_status_effects: __table({
    name: 'my_status_effects',
    indexes: [
    ],
    constraints: [
    ],
  }, MyStatusEffectsRow),
  my_storage: __table({
    name: 'my_storage',
    indexes: [
    ],
    constraints: [
    ],
  }, MyStorageRow),
  my_trade_target_inventory: __table({
    name: 'my_trade_target_inventory',
    indexes: [
    ],
    constraints: [
    ],
  }, MyTradeTargetInventoryRow),
  my_unread_mailbox_counts: __table({
    name: 'my_unread_mailbox_counts',
    indexes: [
    ],
    constraints: [
    ],
  }, MyUnreadMailboxCountsRow),
  my_visible_active_zones: __table({
    name: 'my_visible_active_zones',
    indexes: [
    ],
    constraints: [
    ],
  }, MyVisibleActiveZonesRow),
  visible_actor_inventory: __table({
    name: 'visible_actor_inventory',
    indexes: [
    ],
    constraints: [
    ],
  }, VisibleActorInventoryRow),
  visible_player_identity: __table({
    name: 'visible_player_identity',
    indexes: [
    ],
    constraints: [
    ],
  }, VisiblePlayerIdentityRow),
  visible_players: __table({
    name: 'visible_players',
    indexes: [
    ],
    constraints: [
    ],
  }, VisiblePlayersRow),
});

/** The schema information for all reducers in this module. This is defined the same way as the reducers would have been defined in the server, except the body of the reducer is omitted in code generation. */
const reducersSchema = __reducers(
  __reducerSchema("accept_mail_trade", AcceptMailTradeReducer),
  __reducerSchema("add_friend", AddFriendReducer),
  __reducerSchema("add_to_item_bar", AddToItemBarReducer),
  __reducerSchema("add_to_skill_bar", AddToSkillBarReducer),
  __reducerSchema("add_to_skill_bar_at", AddToSkillBarAtReducer),
  __reducerSchema("admin_add_map_object", AdminAddMapObjectReducer),
  __reducerSchema("admin_add_portal", AdminAddPortalReducer),
  __reducerSchema("admin_add_portal_auto", AdminAddPortalAutoReducer),
  __reducerSchema("admin_add_spawn_point", AdminAddSpawnPointReducer),
  __reducerSchema("admin_bring_player_here", AdminBringPlayerHereReducer),
  __reducerSchema("admin_create_instance", AdminCreateInstanceReducer),
  __reducerSchema("admin_create_map", AdminCreateMapReducer),
  __reducerSchema("admin_delete_map", AdminDeleteMapReducer),
  __reducerSchema("admin_disconnect_player_session", AdminDisconnectPlayerSessionReducer),
  __reducerSchema("admin_import_map_json", AdminImportMapJsonReducer),
  __reducerSchema("admin_move_player_to_map", AdminMovePlayerToMapReducer),
  __reducerSchema("admin_place_npc", AdminPlaceNpcReducer),
  __reducerSchema("admin_reload_map_asset", AdminReloadMapAssetReducer),
  __reducerSchema("admin_remove_map_object", AdminRemoveMapObjectReducer),
  __reducerSchema("admin_remove_npc", AdminRemoveNpcReducer),
  __reducerSchema("admin_remove_portal", AdminRemovePortalReducer),
  __reducerSchema("admin_set_game_manager_role", AdminSetGameManagerRoleReducer),
  __reducerSchema("admin_set_map_biome_region", AdminSetMapBiomeRegionReducer),
  __reducerSchema("admin_set_map_default_biome", AdminSetMapDefaultBiomeReducer),
  __reducerSchema("admin_set_map_path_border_continuation", AdminSetMapPathBorderContinuationReducer),
  __reducerSchema("admin_set_map_path_cell", AdminSetMapPathCellReducer),
  __reducerSchema("admin_set_map_path_tile", AdminSetMapPathTileReducer),
  __reducerSchema("admin_set_map_tile", AdminSetMapTileReducer),
  __reducerSchema("admin_set_player_difficulty", AdminSetPlayerDifficultyReducer),
  __reducerSchema("cancel_status_effect", CancelStatusEffectReducer),
  __reducerSchema("cancel_trade", CancelTradeReducer),
  __reducerSchema("clear_intent_queue", ClearIntentQueueReducer),
  __reducerSchema("create_guild", CreateGuildReducer),
  __reducerSchema("delete_mail", DeleteMailReducer),
  __reducerSchema("enqueue_intent", EnqueueIntentReducer),
  __reducerSchema("enter_dungeon", EnterDungeonReducer),
  __reducerSchema("equip_item", EquipItemReducer),
  __reducerSchema("force_reseed_maps", ForceReseedMapsReducer),
  __reducerSchema("join_guild", JoinGuildReducer),
  __reducerSchema("leave_guild", LeaveGuildReducer),
  __reducerSchema("login", LoginReducer),
  __reducerSchema("logout", LogoutReducer),
  __reducerSchema("mark_incoming_trades_read", MarkIncomingTradesReadReducer),
  __reducerSchema("mark_mail_read", MarkMailReadReducer),
  __reducerSchema("mark_messages_read", MarkMessagesReadReducer),
  __reducerSchema("move_chest_item", MoveChestItemReducer),
  __reducerSchema("move_inventory_item", MoveInventoryItemReducer),
  __reducerSchema("move_inventory_to_storage", MoveInventoryToStorageReducer),
  __reducerSchema("move_storage_item", MoveStorageItemReducer),
  __reducerSchema("move_storage_to_inventory", MoveStorageToInventoryReducer),
  __reducerSchema("persist_tick_result", PersistTickResultReducer),
  __reducerSchema("refresh_session_lease", RefreshSessionLeaseReducer),
  __reducerSchema("register_player", RegisterPlayerReducer),
  __reducerSchema("remove_friend", RemoveFriendReducer),
  __reducerSchema("remove_from_item_bar", RemoveFromItemBarReducer),
  __reducerSchema("remove_from_skill_bar", RemoveFromSkillBarReducer),
  __reducerSchema("send_chat", SendChatReducer),
  __reducerSchema("send_mail", SendMailReducer),
  __reducerSchema("set_my_appearance", SetMyAppearanceReducer),
  __reducerSchema("split_chest_item", SplitChestItemReducer),
  __reducerSchema("split_inventory_item", SplitInventoryItemReducer),
  __reducerSchema("start_ticker", StartTickerReducer),
  __reducerSchema("take_item_from_chest", TakeItemFromChestReducer),
  __reducerSchema("take_item_from_chest_to_slot", TakeItemFromChestToSlotReducer),
  __reducerSchema("unequip_item", UnequipItemReducer),
  __reducerSchema("update_player_position", UpdatePlayerPositionReducer),
  __reducerSchema("use_item_on_tile", UseItemOnTileReducer),
  __reducerSchema("use_portal", UsePortalReducer),
  __reducerSchema("verify_inventory_access", VerifyInventoryAccessReducer),
  __reducerSchema("verify_item_definition_access", VerifyItemDefinitionAccessReducer),
  __reducerSchema("verify_map_access", VerifyMapAccessReducer),
  __reducerSchema("verify_trade_target", VerifyTradeTargetReducer),
);

/** The schema information for all procedures in this module. This is defined the same way as the procedures would have been defined in the server. */
const proceduresSchema = __procedures(
);

/** The remote SpacetimeDB module schema, both runtime and type information. */
const REMOTE_MODULE = {
  versionInfo: {
    cliVersion: "2.0.5" as const,
  },
  tables: tablesSchema.schemaType.tables,
  reducers: reducersSchema.reducersType.reducers,
  ...proceduresSchema,
} satisfies __RemoteModule<
  typeof tablesSchema.schemaType,
  typeof reducersSchema.reducersType,
  typeof proceduresSchema
>;

/** The tables available in this remote SpacetimeDB module. Each table reference doubles as a query builder. */
export const tables: __QueryBuilder<typeof tablesSchema.schemaType> = __makeQueryBuilder(tablesSchema.schemaType);

/** The reducers available in this remote SpacetimeDB module. */
export const reducers = __convertToAccessorMap(reducersSchema.reducersType.reducers);

/** The context type returned in callbacks for all possible events. */
export type EventContext = __EventContextInterface<typeof REMOTE_MODULE>;
/** The context type returned in callbacks for reducer events. */
export type ReducerEventContext = __ReducerEventContextInterface<typeof REMOTE_MODULE>;
/** The context type returned in callbacks for subscription events. */
export type SubscriptionEventContext = __SubscriptionEventContextInterface<typeof REMOTE_MODULE>;
/** The context type returned in callbacks for error events. */
export type ErrorContext = __ErrorContextInterface<typeof REMOTE_MODULE>;
/** The subscription handle type to manage active subscriptions created from a {@link SubscriptionBuilder}. */
export type SubscriptionHandle = __SubscriptionHandleImpl<typeof REMOTE_MODULE>;

/** Builder class to configure a new subscription to the remote SpacetimeDB instance. */
export class SubscriptionBuilder extends __SubscriptionBuilderImpl<typeof REMOTE_MODULE> {}

/** Builder class to configure a new database connection to the remote SpacetimeDB instance. */
export class DbConnectionBuilder extends __DbConnectionBuilder<DbConnection> {}

/** The typed database connection to manage connections to the remote SpacetimeDB instance. This class has type information specific to the generated module. */
export class DbConnection extends __DbConnectionImpl<typeof REMOTE_MODULE> {
  /** Creates a new {@link DbConnectionBuilder} to configure and connect to the remote SpacetimeDB instance. */
  static builder = (): DbConnectionBuilder => {
    return new DbConnectionBuilder(REMOTE_MODULE, (config: __DbConnectionConfig<typeof REMOTE_MODULE>) => new DbConnection(config));
  };

  /** Creates a new {@link SubscriptionBuilder} to configure a subscription to the remote SpacetimeDB instance. */
  override subscriptionBuilder = (): SubscriptionBuilder => {
    return new SubscriptionBuilder(this);
  };
}

